function init_fourorgasms() {
  var main = $(".place.fourorgasms");

  main.promoBlinkPlay();
}
